define('FixSearchBox.SiteSearch.View',
    [
        'SiteSearch.View'
    ], function(
        SiteSearchView
    ) {
        'use strict';

        _.extend(SiteSearchView.prototype, {
            initialize: _.wrap(SiteSearchView.prototype.initialize, function (fn) {
                fn.apply(this, _.toArray(arguments).slice(1));
                var layout = this.options.application.getLayout();
                layout.on('afterAppendView', function(view) {
                    $('.header-site-search.search-mobile').show();
                });

                jQuery(window).scroll(function(){
                    jQuery('.header-site-search.search-mobile').show();
                })
            }),
            toggleItemSearcher: function() {
            },

            hideItemSearcher: function() {
            }
        });
    }
)
